import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { LinkItem } from '../link-item';

@Component({
  selector: 'app-link-items-manage',
  templateUrl: './link-items-manage.component.html',
  styleUrls: ['./link-items-manage.component.css']
})
export class LinkItemsManageComponent implements OnInit {

  linkItems: LinkItem[] = [];
  selectedLink: LinkItem | null = null;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit() {
    this.initLinks();
  }

  initLinks(){
    this.httpService.getAllLinkItems().subscribe(res => {
      this.linkItems = res;
    });
  }

  select(link: LinkItem){
    this.selectedLink = link;
  }

  delete(){
    this.httpService.deleteLinkItem(this.selectedLink!).subscribe(() => {
      this.selectedLink = null;
      this.initLinks();
    });
  }

}
